import moment from 'moment'

export const MAX_DAYS = 35

export const getWeekdays = () => Array.apply(null, Array(7)).map((_, i) => {
	return moment(i, 'e').startOf('week').isoWeekday(i + 1).format('ddd')
})

export const chunkArray = (myArray, chunkSize) => {
	let index = 0,
		arrayLength = myArray.length,
		tempArray = []
	for (index = 0; index < arrayLength; index += chunkSize) {
		const myChunk = myArray.slice(index, index + chunkSize)
		tempArray.push(myChunk)
	}
	return tempArray
}

export const getDaysArray = (year, month) => {
	const monthIndex = month - 1,
		date = new Date(year, monthIndex, 1),
		result = []
	while (date.getMonth() === monthIndex) {
		result.push(!date.getDay() ? 7 : date.getDay())
		date.setDate(date.getDate() + 1)
	}
	const prevMonthLastDay = moment(
		`${month > 9 ? month : `0${month}`}/${year}`, 'MM/YYYY'
	).subtract(1, 'months').endOf('month').format('DD')
	const prevMonthDays = Array.from(Array(result[0] - 1).keys()).map(day => {
		return { value: Number(prevMonthLastDay) - day, blank: true }
	}).reverse()
	const resultToDays = result.map((_, index) => ({
		value: index + 1,
		blank: false
	}))
	resultToDays.unshift(...prevMonthDays)
	const nextMonthDays = MAX_DAYS - resultToDays.length
	if (nextMonthDays > 0) {
		resultToDays.push(
			...Array.from(Array(nextMonthDays).keys())
				.map((_, index) => ({ value: index + 1, blank: true }))
		)
	}
	return chunkArray(resultToDays, 7)
}

export const getValidDateNumber = (value) => {
	return value > 9 ? value : `0${value}`
}
